import { Route } from '@angular/router';

export const appRoutes: Route[] = [{ path: '**', redirectTo: 'willkommen', pathMatch: 'full' }];
